import { useEffect, useState } from "react";
import { Search } from "react-bootstrap-icons";
import { AiOutlinePlus } from "react-icons/ai";
import { BsExclamation } from "react-icons/bs";
import { CiFilter } from "react-icons/ci";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { Button, Input, InputGroup, InputGroupText } from "reactstrap";
import { masterDataActions } from "../../actions/masterData.action";
import ConfirmDialog from "../../components/common/ConfirmDialog/ConfirmDialog";
import ModalDialog from "../../components/common/Modal/Modal";
import useModal from "../../components/Hooks/useModal";
import AddMasterData from "../../components/MasterDataForm/MasterDataForm";
import ProfileComponent from "../../components/ProfileComponent/ProfileComponent";
import SkillsComponent from "../../components/SkillsComponent/SkilsComponent";
import styles from "./MasterData.module.scss"


const MasterData = () => {
  const { toggle: addMasterDataToggle, visible: masterVisible } = useModal();
  let { toggle: ConfirmToggle, visible: ConfirmModal } = useModal();
  const [editedData, setEditedData] = useState(null);
  const [deleteId, setDeleteId] = useState(null);
  const [filterText, setFilterText] = useState("");
  const [activeTab, setActiveTab] = useState(true);
  const error = useSelector(state=>state.masterData.error)
  const searchChange = (e) => {
    setFilterText(e?.target?.value);
  };
  const dispatch = useDispatch()
  useEffect(() => {
    if (!activeTab) {
      dispatch(masterDataActions.getSkills())
    }
  }, [activeTab])


  // useEffect(() => {
  //   if(error){
  //     ConfirmToggle()
  //   }
  // }, [error])
  



  return (
    <>
    <div className={styles.MasterData}>
      <div className="main-header-buttons">
        <div className={styles.buttonPart}>
          <Button
            type="button"
            onClick={() => addMasterDataToggle()}
            className={styles.brandButton}
          >
            <AiOutlinePlus /> Add
          </Button>
        </div>
        <div>
          {/* <InputGroup>
            <InputGroupText className="search-addon">
              <Search />{" "}
            </InputGroupText>
            <Input
              className="search-input"
              placeholder="Search"
              value={filterText}
              onChange={(e) => {
                searchChange(e);
              }}
            />
            <Button type="button" className="btn filter-btn" id="filter-button">
              <CiFilter />
              Filter
            </Button>
          </InputGroup> */}
        </div>
      </div>
      <div className={styles.tabPart}>
        <div className={styles.tabButtonGroup}>
          <div
            className={`${styles.commentPart} ${activeTab ? styles.active : ""
              }`}
            onClick={() => setActiveTab(true)}
          >
            Profile
          </div>
          <div
            className={`${styles.historyPart} ${!activeTab ? styles.active : ""
              }`}
            onClick={() => setActiveTab(false)}
          >
            Skills
          </div>
        </div>
      </div>
      {activeTab ? <ProfileComponent setActiveTab={setActiveTab} /> : <SkillsComponent setActiveTab={setActiveTab} />}
      <ModalDialog
        toggle={addMasterDataToggle}
        title={`${editedData !== null ? "Update" : "Add"} Master Data`}
        visible={masterVisible}
        size="md"
        bodyClass="p-0"
      >
        <AddMasterData addMasterDataToggle={addMasterDataToggle} activeTab={activeTab} setActiveTab={setActiveTab}  />
      </ModalDialog>
    </div>
             {/* <ConfirmDialog
                visible={ConfirmModal}
                toggle={ConfirmToggle}
                type = 'info'
                masterInfo='masterInfo'
                activeBtnClick={() => {
                  console.log('hello');
              }}
                title={<>There are openings related to  the Department/ Designation you are trying to delete.</>}
            >
                <div className={`confirmIcon rounded-circle`}>
                    <BsExclamation style={{ fontSize: 42 }} />
                </div>
            </ConfirmDialog> */}
    </>
  )
}

export default MasterData;